var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8788 72.8801L24.8794 90.8795L29.122 95.1221L47.1214 77.1227L42.8788 72.8801Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5001 84C48.7851 84 36.0001 71.215 36.0001 55.5C36.0001 39.785 48.7851 27 64.5001 27C80.2151 27 93.0001 39.785 93.0001 55.5C93.0001 71.215 80.2151 84 64.5001 84ZM64.5001 33C52.0926 33 42.0001 43.0925 42.0001 55.5C42.0001 67.9075 52.0926 78 64.5001 78C76.9076 78 87.0001 67.9075 87.0001 55.5C87.0001 43.0925 76.9076 33 64.5001 33Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.61d48b9c.svg";
export { ForwardRef as ReactComponent };